import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Description as FollowUsOnFacebookDescription } from "scmp-sdk/components/follow-us-on-facebook/styles";
import {
  Container as FindOutMoreContainer,
  Message as FindOutMoreMessage,
} from "scmp-sdk/components/newsletter/newsletter-widget/find-out-more/styles";
import {
  StyledIconArrowPrevious,
  StyledSignupButton,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { IconContainer as SocialButtonIconContainer } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import {
  AgreementDescription,
  ActionContainer as SignUpActionContainer,
  AgreementContainer as SignUpAgreementContainer,
  AgreementDescription as SignUpNewsletterAgreementDescription,
  Container as SignUpNewsletterContainer,
  SummaryContainer as SignUpNewsletterSummaryContainer,
  StyledSignUpButton as SignUpStyledSignUpButton,
  TermAndConditionContainer as SignUpTermAndConditionContainer,
  TermAndConditionLink as SignUpTermAndConditionLink,
  TitleContainer as SignUpTitleContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/styles";
import {
  Container as SignUpSuccessMessageContainer,
  CheckEmailMessage as SingUpSuccessCheckEmailMessage,
  Title as SingUpSuccessTitle,
  StyledFollowUsOnFacebook,
  StyledIconTickCircle,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-success-message/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { StyledFillEmailIcon } from "./article-20-theme-sign-up-button-display/styles";

export const theme: ThemeType = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "black",
  },
  orientation: "portrait",
  root: {
    containerSize: "custom",
    customCss: css`
      max-inline-size: 260px;
    `,
  },
  signUpNewsletter: {
    checkboxStyle: "primary",
    hasDescription: false,
    summaryFontStyle: "medium",
    titleFontStyle: "large",
  },
  signUpSuccess: {
    checkEmailMessageStyle: "",
    hasCheckEmail: true,
    hasSeeMoreLinks: false,
    titleFontStyle: "medium",
  },
};

export const Container = styled.div`
  ${SignUpSuccessMessageContainer} {
    grid-template-areas:
      "Title Icon"
      "Footer Footer";
    grid-template-columns: 1fr min-content;

    color: #000000;
    text-align: start;

    ${SingUpSuccessTitle} {
      font-weight: 700;
      font-size: 18px;
      font-family: ${fontRobotoCondensed};
      line-height: normal;
    }

    ${SingUpSuccessCheckEmailMessage} {
      margin-block-end: 12px;

      font-size: 12px;
      font-family: ${fontRoboto};
      line-height: normal;
    }

    ${StyledFollowUsOnFacebook} {
      margin-block-start: 0;
      ${FollowUsOnFacebookDescription} {
        color: #666666;
        font-size: 10px;
        line-height: normal;
      }
    }

    ${StyledIconTickCircle} {
      path:first-child {
        fill: #eb4254;
      }

      path:last-child {
        fill: #ffffff;
      }
    }
  }

  ${FindOutMoreContainer} {
    text-align: center;
    ${FindOutMoreMessage} {
      color: #000000;
    }

    ${StyledFillEmailIcon} {
      display: none;
    }
  }

  ${SignUpNewsletterContainer} {
    justify-items: left;

    color: #000000;
    font-family: ${fontRobotoCondensed};
    text-align: start;

    ${StyledIconArrowPrevious} {
      path {
        stroke: #000000;
      }
    }

    ${SignUpNewsletterAgreementDescription} {
      color: #999999;
    }

    ${SignUpTermAndConditionContainer}, ${SignUpTermAndConditionLink} {
      color: #666666;
    }

    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }

    ${SignUpStyledSignUpButton} {
      inline-size: 100%;
      block-size: 38px;
    }

    ${StyledSignupButton} {
      min-inline-size: 70px;

      font-size: 12px;
      font-family: ${fontRoboto};
      line-height: 14px;
    }

    ${SignUpTitleContainer}, ${SignUpActionContainer}, ${SignUpNewsletterSummaryContainer} {
      margin-block-end: 12px;
    }

    ${SignUpActionContainer} {
      inline-size: 100%;
    }

    ${SignUpAgreementContainer} {
      flex-direction: row-reverse;
      gap: 8px;
      ${AgreementDescription} {
        margin-inline-end: 0;

        color: #333333;
        font-weight: 400;
        font-size: 11px;
        font-family: ${fontRoboto};
        line-height: 13px;
      }
    }
  }
`;
